let accessToken = null
let accessTokenExpiry = 0

export const setAccessToken = (token, expiresInSeconds) => {
  accessToken = token || null
  accessTokenExpiry = token && expiresInSeconds
    ? Date.now() + Number(expiresInSeconds) * 1000
    : 0
}

export const getAccessToken = () => accessToken

export const isAccessTokenValid = () => {
  if (!accessToken) return false
  if (!accessTokenExpiry) return true
  return Date.now() < accessTokenExpiry - 5000
}

export const clearAccessToken = () => {
  accessToken = null
  accessTokenExpiry = 0
}
